import { createSlice } from '@reduxjs/toolkit';
import { IQueryParams } from '../../../models/common/IQueryParams';
import { SORT_STRINGS } from '../../../constants/EventConstants';
import { defaultEventListStatus } from '../../../utilities/events/EventsListUtils';

/**
 * Initial All Event state in store
 */

export interface IEventFilterState extends IQueryParams {
  sort: string;
  clearData: string;
}

const initialState: IEventFilterState = {
  searchText: '',
  status: defaultEventListStatus,
  toDate: null,
  fromDate: null,
  sort: SORT_STRINGS.LAST_MODIFIED,
  clearData: '',
};

const filterEventSlice = createSlice({
  name: 'filterEvent',
  initialState,
  reducers: {
    addFilterEventData: (state, action) => {
      state.searchText = action.payload.searchText;
      state.status = action.payload.status;
      state.toDate = action.payload.toDate;
      state.fromDate = action.payload.fromDate;
    },
    addSortEventData: (state, action) => {
      state.sort = action.payload;
    },
    addClearData: (state, action) => {
      state.clearData = action.payload;
    },
    clearFilterEvent: (state) => {
      state.status = '';
      state.toDate = null;
      state.fromDate = null;
      state.sort = '';
    },
    clearQueryParamEvent: (state) => {
      state.searchText = '';
      state.status = '';
      state.toDate = null;
      state.fromDate = null;
      state.sort = '';
    },
    removeClearData: (state) => {
      state.clearData = '';
    }
  }
});
export const {
  addFilterEventData,
  clearFilterEvent,
  addSortEventData,
  removeClearData,
  addClearData,
  clearQueryParamEvent
} = filterEventSlice.actions;
export default filterEventSlice.reducer;
